import { call, takeLatest, select } from 'redux-saga/effects';
import logger from '@tcp/core/src/utils/loggerInstance';
import { urlContainsQuery } from '@tcp/core/src/utils';
import { getBrandTabAnchorToButtonEnabled } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { NavigateXHR } from '@tcp/core/src/services/abstractors/account/NavigateXHR';
import { BRAND_TABS_CONSTANTS } from './BrandTabs.constants';

const getUpdatedUrl = ({ url, cookieToken }) => {
  if (urlContainsQuery(url)) {
    return `${url}&ct=${cookieToken}`;
  }
  return `${url}?ct=${cookieToken}`;
};

/*
Added New Function to move to home screen when it is in active tab
*/
const getActiveTabUrl = (url) => {
  const activeUrl = new URL(url);
  return `${window.location.protocol}//${window.location.host}/us/home/${activeUrl.search}`;
};

const getUrlWithAdobeIdentity = async (ahref) => {
  let url = ahref;
  try {
    await window.alloy('appendIdentityToUrl', { url: ahref }).then((result) => {
      url = result?.url || ahref;
    });
  } catch (ex) {
    logger.error('Exception in getUrlWithAdobeIdentity: ', ex);
  }
  return url;
};

export function* handleBrandNavigation({ payload }) {
  const { brandName = '', active, url, target = '_self' } = payload || {};
  try {
    if (!active) {
      const urlWithAdobeIdentity = yield call(getUrlWithAdobeIdentity, url);
      const response = yield call(NavigateXHR, '', {}, brandName);
      const brandTabAnchorToButtonEnabled = yield select(getBrandTabAnchorToButtonEnabled);
      const { encodedCookie = '' } = response && response.data;
      if (encodedCookie) {
        const Url = getUpdatedUrl({ url: urlWithAdobeIdentity, cookieToken: encodedCookie });
        if (brandTabAnchorToButtonEnabled) {
          window.location.href = Url;
        } else {
          window.open(Url, target);
        }
      }
    } else {
      const brandTabAnchorToButtonEnabled = yield select(getBrandTabAnchorToButtonEnabled);
      const activeUrl = getActiveTabUrl(url);
      if (brandTabAnchorToButtonEnabled) {
        window.location.href = activeUrl;
      } else {
        window.open(activeUrl, target);
      }
    }
  } catch (err) {
    logger.error(err);
  }
}

function* BrandTabsSaga() {
  yield takeLatest(BRAND_TABS_CONSTANTS.BRAND_TABS_NAVIGATION_XHR, handleBrandNavigation);
}

export default BrandTabsSaga;
